module.exports = __webpack_public_path__ + "media/images/tl/banner/zh-hans-dark-9e848c06948b4c3cce470fe1715ac497.jpg";